<ng-container *ngIf="showInvoiceDetails">
	<ng-template #invoiceDetails let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-title">{{ displaydetails.title }}</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
		</div>
		<div class="modal-body">
			<div class="mb-3" *ngIf="displaydetails">
				<h4></h4>
				<ng-container *ngIf="displaydetails.type == 'html'">
					<div [innerHTML]="displaydetails.display">
					</div>
				</ng-container>
				<ng-container *ngIf="displaydetails.type == 'pdf'">
					<ngx-extended-pdf-viewer [base64Src]="displaydetails.display" useBrowserLocale="true" [handTool]="false" [textLayer]="true" [showOpenFileButton]="false" [showPropertiesButton]="false" [showHandToolButton]="true" [filenameForDownload]="displaydetails.title"></ngx-extended-pdf-viewer>
				</ng-container>
			</div>
		</div>
		<div class="modal-footer">
		</div>
	</ng-template>
</ng-container>
<ng-container *ngIf="showOrderDetails">
	<ng-template #orderDetails let-modal>
		<div class="modal-header">
			<div class="modal-title row m-0 p-0" id="modal-title">
				<h4>Order# {{orderdetails.header.orderno}}</h4>
			</div>
			<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
		</div>
		<div class="modal-body">
			<div class="mb-3" *ngIf="orderdetails">
				<div class="" *ngIf="orderdetails.dispatch_details && orderdetails.dispatch_details.status_id == '29'">

					<div #mapDiv class="w-100" [ngClass]="{'d-none': !orderdetails.dispatch_details.nextlast}">
						EST: {{orderdetails.dispatch_details.nextlast }}
						<div class="w-100" id="map">
						</div>
					</div>
				</div>

				<div class="row border-bottom">
					<div class="col-md-3 text-center">
						<h5>Ship Via: {{ orderdetails.header.shippername }}</h5>
					</div>
					<div class="col-md-3 text-center">
						<h5>Date Wanted: {{ orderdetails.header.datewanted }}</h5>
					</div>
					<div class="col-md-3 text-center">
						<h5>Entered By: {{ orderdetails.header.enteredby }}</h5>
					</div>
					<div class="col-md-3 text-center">
						<h5>Created: {{ orderdetails.header.date_created }}</h5>
					</div>
				</div>
				<ng-container *ngIf="orderdetails.header.processed_phase || orderdetails.header.invoice_message || orderdetails.header.tpl3pl_tracking_number">
					<div class="row border-bottom mt-2 mb-2">
						<div class="col-12">
							<span class="phase-badge phase-{{ orderdetails.header.processed_phase }}" *ngIf="orderdetails.header.processed_phase">{{ orderdetails.header.processed_phase }}</span>
							<span class="text-muted small ml-2" *ngIf="orderdetails.header.invoice_message">{{ orderdetails.header.invoice_message }}</span>
							<span class="ml-2" *ngIf="orderdetails.header.tpl3pl_tracking_number">3PL Tracking:
								<ng-container *ngIf="(orderdetails.header.tpl3pl_tracking_number | trackingUrl:(orderdetails.header.tpl3pl_carrier || '3PL')) as oiHref; else oiTplPlain">
									<a class="tracking-link" [href]="oiHref" target="_blank" rel="noopener noreferrer">{{ orderdetails.header.tpl3pl_tracking_number }}</a>
								</ng-container>
								<ng-template #oiTplPlain>{{ orderdetails.header.tpl3pl_tracking_number }}</ng-template>
							</span>
						</div>
					</div>
				</ng-container>
				<div class="row mt-2 mb-2 border-bottom">
					<div class="col-md-3 ">
						<h5 class="mb-0">Ship To:</h5>
						<mat-divider></mat-divider>
						<span class="mt-2" [innerHTML]="orderdetails.header.shipto"></span>
					</div>
					<div class="col-md-3">
						<h5 class="mb-0">Phone:</h5>
						<mat-divider></mat-divider>
						<span class="mt-2">{{orderdetails.header.contactphone}}</span>

						<ng-container *ngIf="orderdetails.header.contactemail && orderdetails.header.contactemail != ''">
							<h5 class="mb-0 mt-2">Email:</h5>
							<mat-divider></mat-divider>
							<span class="mt-2">{{orderdetails.header.contactemail}}</span>
						</ng-container>
					</div>
					<div class="col-md-3">
						<h5 class="mb-0">Notes:</h5>
						<mat-divider></mat-divider>
						<span class="mt-2">{{orderdetails.header.comments}}</span>
					</div>
					<div class="col-md-3">
						<h5 class="mb-0">History: </h5>
						<mat-divider></mat-divider>
						<ng-container *ngIf="orderdetails.dispatch_details.dispatch_id">
							<ul class="mt-2">
								<li *ngIf="orderdetails.dispatch_details.truck_name">
									ShipVia: {{ orderdetails.dispatch_details.truck_name }}<br>
									{{ orderdetails.dispatch_details.driveruserid }}
								</li>
								<li *ngIf="orderdetails.dispatch_details.datecreated !='0000-00-00 00:00:00'">Dispatched:
									{{ orderdetails.dispatch_details.datecreated | date:'shortDate' }}
									{{ orderdetails.dispatch_details.datecreated | date:'shortTime' }}

								</li>
								<li *ngIf="orderdetails.dispatch_details.delivery_date !='0000-00-00 00:00:00'">Delivered:
									{{ orderdetails.dispatch_details.delivery_date | date:'shortDate' }}
									{{ orderdetails.dispatch_details.delivery_date | date:'shortTime' }}
								</li>
							</ul>
						</ng-container>
						<ng-container *ngIf="!orderdetails.dispatch_details.dispatch_id">
							N/A
						</ng-container>
					</div>
				</div>
				<div class="table">
					<table class="table table-sm fs-bigger">
						<tr>
							<th>ITEM</th>
							<th>DESC</th>
							<th class="text-center">QOH</th>
							<th class="text-center">ORDERED</th>
							<th class="text-center">INVOICED</th>
							<th class="text-center">OUTSTANDING</th>
							<th class="text-right">PRICE</th>
							<th class="text-right" *ngIf="config.discounts">DISCOUNT</th>
							<th class="text-right">TOTAL</th>
						</tr>
						<tr *ngFor="let item of orderdetails.details">

							<td>{{item.stkcode}}</td>
							<td>{{item.description}}</td>
							<td class="text-center">{{item.qoh}}</td>
							<td class="text-center">{{item.ordered}}</td>
							<td class="text-center">{{item.qtyinvoiced}}</td>
							<td class="text-center">{{item.ordered - item.qtyinvoiced}}</td>
							<td class="text-right">{{item.unitprice | currency}}</td>
							<td class="text-right" *ngIf="config.discounts">{{item.discountpercent | percent }}</td>
							<td class="text-right">{{item.discountprice * item.ordered | currency}}</td>
						</tr>
						<tr *ngFor="let t of orderdetails.saved_totals">
							<td></td>
							<td></td>
							<td></td>
							<td class="text-center"></td>
							<td class="text-center"></td>
							<td class="text-center"></td>
							<td class="text-center" *ngIf="config.discounts"></td>
							<td class="text-right">{{ t.title }}:</td>
							<td class="text-right">{{t.text | currency}}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<div class="modal-footer">
		</div>
	</ng-template>
</ng-container>
<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Order Inquiry
						</h4>
						<p class="card-category text-right">Search For an Order/Invoice</p>
					</div>
					<div class="card-body">
						<form class="navbar-form" (ngSubmit)="searchOrders()">
							<div class="row g-3">
								<!-- Order Type -->
								<div class="col-12 col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Order Type</mat-label>
										<mat-select [formControl]="orderSearchTypeRef">
											<mat-option value="O">Orders</mat-option>
											<mat-option value="I">Invoices</mat-option>
											<mat-option value="B">Both</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

								<!-- Keywords -->
								<div class="col-12 col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Search for an Order/Invoice</mat-label>
										<span matPrefix *ngIf="orderSearchRef.value">
											<button mat-icon-button type="button" (click)="clearForm()" aria-label="Clear search">
												<mat-icon>clear</mat-icon>
											</button>
										</span>
										<input matInput [formControl]="orderSearchRef" autocomplete="off" (keydown.enter)="$event.preventDefault(); searchOrders()" />
										<span matSuffix>
											<button mat-icon-button type="submit" aria-label="Search">
												<mat-icon>search</mat-icon>
											</button>
										</span>
									</mat-form-field>
								</div>

								<!-- Customer # -->
								<div class="col-12 col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Customer #</mat-label>
										<input matInput [formControl]="customerNumberRef" placeholder="e.g. 12345 or 123.01" autocomplete="off" (keydown.enter)="$event.preventDefault(); searchOrders()" />
										<span matSuffix *ngIf="customerNumberRef.value">
											<button mat-icon-button type="button" (click)="customerNumberRef.reset('')" aria-label="Clear customer number">
												<mat-icon>clear</mat-icon>
											</button>
										</span>
									</mat-form-field>
								</div>

								<!-- Date Range -->
								<div class="col-12 col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Date range</mat-label>
										<mat-date-range-input [rangePicker]="picker">
											<input matStartDate placeholder="Start date" [formControl]="startDateRef" (keydown.enter)="$event.preventDefault(); searchOrders()" />
											<input matEndDate placeholder="End date" [formControl]="endDateRef" (keydown.enter)="$event.preventDefault(); searchOrders()" />
										</mat-date-range-input>
										<mat-datepicker-toggle matSuffix [for]="picker" aria-label="Open date range picker"></mat-datepicker-toggle>
										<mat-date-range-picker #picker></mat-date-range-picker>
									</mat-form-field>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-12 text-right">
									<button mat-raised-button type="submit" color="primary" [disabled]="sending">
										<mat-icon>search</mat-icon>
										Search
									</button>
								</div>
							</div>
						</form>
						<span *ngIf="sending">
							<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
							</svg>
						</span>

						<!-- Actions (kept) -->
						<div class="results-actions" *ngIf="!sending">
							<button mat-raised-button type="button" color="warn" (click)="exportPdf()" [disabled]="!orderResults">
								<i class="fa fa-file-pdf-o" aria-hidden="true"></i> PDF
							</button>
							<button mat-raised-button type="button" color="primary" (click)="exportXls()" [disabled]="!orderResults">
								<i class="fa fa-file-excel-o" aria-hidden="true"></i> XLS
							</button>
						</div>

						<!-- Cards Container -->
						<div #resultTable class="order-cards" *ngIf="orderResults?.length">
							<div class="order-card" *ngFor="let o of orderResults; trackBy: trackOrder">

								<!-- Header -->
								<div class="order-header">
									<div class="order-header-main">
										<div class="order-id">
											<span class="order-label">{{ o.type === 'credit' ? 'Credit #' : 'Order #' }}</span>
											<span class="order-number">{{ o.orderno }}</span>
										</div>

										<!-- Actions or Credit View -->
										<div class="order-actions">
											<ng-container *ngIf="o.type !== 'credit'; else creditLink">
												<button mat-icon-button [matMenuTriggerFor]="orderMenu" aria-label="Actions" class="noprint">
													<mat-icon>more_vert</mat-icon>
												</button>
												<mat-menu #orderMenu="matMenu">
													<a [href]="invoicelink + o.orderno" mat-menu-item>
														<mat-icon>print</mat-icon>
														<span>Customer Copy</span>
													</a>
													<mat-divider></mat-divider>
													<a *ngIf="o.id" [href]="invoicelink2 + o.id" mat-menu-item>
														<mat-icon>print</mat-icon>
														<span>Invoice</span>
													</a>
													<a [href]="pickinglink + o.orderno" mat-menu-item>
														<mat-icon>print</mat-icon>
														<span>Picking PDF</span>
													</a>
												</mat-menu>
											</ng-container>
											<ng-template #creditLink>
												<a [href]="creditlink + o.id" class="icon-link" aria-label="View Credit">
													<mat-icon>visibility</mat-icon>
												</a>
											</ng-template>
										</div>

										<!-- Status Badge -->
										<span class="status-badge" [ngClass]="statusClass(o.orderstatusid)">
											{{ o.statusname }}
										</span>
									</div>

									<!-- Meta Grid -->
									<div class="order-header-meta">
										<div><span>Created</span><strong>{{ safeDate(o.date_created) ? (safeDate(o.date_created) | date:'short') : 'N/A' }}</strong></div>
										<div><span>Updated</span><strong>{{ safeDate(o.date_updated) ? (safeDate(o.date_updated) | date:'short') : 'N/A' }}</strong></div>
										<div><span>Customer</span><strong><a class="link" (click)="viewCustomer(o.debtorno)">{{ o.debtorno }}.{{ o.branchcode }}</a></strong></div>
										<div><span>PO / Ref</span><strong>{{ o.customerref || '—' }}</strong></div>
										<div><span>Deliver To</span><strong class="truncate">{{ o.deliverto || '—' }}</strong></div>
										<div>
											<span>Dispatch</span>
											<strong>
												<ng-container *ngIf="o.dispatch?.driveruserid; else noDispatch">
													{{ o.dispatch.driveruserid }}
													<ng-container *ngIf="safeDate(o.dispatch?.datecreated)">
														· {{ safeDate(o.dispatch.datecreated) | date:'short' }}
													</ng-container>
												</ng-container>
												<ng-template #noDispatch>N/A</ng-template>
											</strong>
										</div>
										<div>
											<span>Delivered</span>
											<strong>
												<ng-container *ngIf="safeDate(o.dispatch?.delivery_date); else noDelivered">
													{{ safeDate(o.dispatch.delivery_date) | date:'short' }}
												</ng-container>
												<ng-template #noDelivered>N/A</ng-template>
											</strong>
										</div>
										<div><span>Entered By</span><strong>{{ o.enteredby || '—' }}</strong></div>
										<div><span>Edited By</span><strong>{{ o.takenby || '—' }}</strong></div>
									</div>
								</div>

								<!-- Items Section -->
								<div class="order-body">
									<table class="table table-sm items-table">
										<thead>
											<tr>
												<th class="">Item</th>
												<th class="desc">Desc</th>
												<th class="text-end w-min">QOH</th>
												<th class="text-end w-min">{{ o.type === 'credit' ? 'Credited' : 'Ordered' }}</th>
												<th class="text-end w-min">Invoiced</th>
												<th class="text-end w-min">Outstanding</th>
												<th class="text-end w-min">Price</th>
												<th class="text-end w-min" *ngIf="config?.discounts">Discount</th>
												<th class="text-end w-min">Total</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let det of o.details">
												<td class="mono">{{ det.stkcode }}</td>
												<td class="wrap">{{ det.itemdesc }}</td>
												<td class="text-end num">{{ safeNum(det.qoh ?? det.QOH) }}</td>
												<td class="text-end num">{{ safeNum(det.quantity ?? det.ordered) }}</td>
												<td class="text-end num">{{ safeNum(det.qtyinvoiced) }}</td>
												<td class="text-end num">{{ safeNum((det.quantity ?? det.ordered) - safeNum(det.qtyinvoiced)) }}</td>
												<td class="text-end num">{{ safeNum(det.unitprice) | currency }}</td>
												<td class="text-end num" *ngIf="config?.discounts">
													{{ (safeNum(det.discountpercent) / 100) | percent:'1.0-2' }}
												</td>
												<td class="text-end num">
													{{ (safeNum(getDiscountTotal(det)) * (o.type === 'credit' ? -1 : 1)) | currency }}
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<!-- Totals Footer -->
								<div class="order-footer">
									<div class="sum">
										<span>Tax</span>
										<strong>{{ (getValueByType(o.payment_details, 'tax') * (o.type === 'credit' ? -1 : 1)) | currency }}</strong>
									</div>
									<div class="sum">
										<span>Subtotal</span>
										<strong>{{ ((getValueByType(o.payment_details, 'subtotal') || getValueByType(o.payment_details, 'sub_total')) * (o.type === 'credit' ? -1 : 1)) | currency }}</strong>
									</div>
									<div class="sum total">
										<span>Total</span>
										<strong>{{ (getValueByType(o.payment_details, 'total') * (o.type === 'credit' ? -1 : 1)) | currency }}</strong>
									</div>
								</div>
							</div>
						</div>

						<!-- Fallback -->
						<h4 *ngIf="!orderResults?.length && !sending" class="text-center">No results</h4>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>